import * as projectService from "V2.0/services/projectService";

import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogBody,
  DialogTitle,
  DialogActions,
  DialogDescription,
} from "V2.0/common/dialog";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "V2.0/common/table";
import { Switch } from "V2.0/common/switch";

export default function UserAccessWorkspaces(props) {
  const { user, open, onClose, workspaces, company, syncWorkspace } = props;

  const removeUserFromWorkspace = (workspace, userId) => {
    return {
      ...workspace,
      userAdmin: workspace.userAdmin.filter((_userId) => _userId !== userId),
    };
  };

  const addUserToWorkspace = (workspace, userId) => {
    return {
      ...workspace,
      userAdmin: [...workspace.userAdmin, userId],
    };
  };

  const updateUserAccessToWorkspace = async (workspace, isActive) => {
    const emailArray = [user.email];
    isActive
      ? message.loading(`Adding to ${workspace.name}`)
      : message.loading(`Removing from ${workspace.name}`);
    try {
      const response = await projectService.updateTeamAccess({
        companyId: company._id,
        workspaceId: workspace._id,
        payload: {
          emails: emailArray,
          active: isActive,
        },
      });

      if (response.status === 200) {
        message.destroy();

        isActive
          ? message.success(`Added to ${workspace.name}`)
          : message.success(`Removed from ${workspace.name}`);

        const updatedWorkpsace = isActive
          ? addUserToWorkspace(workspace, user._id)
          : removeUserFromWorkspace(workspace, user._id);
        syncWorkspace(updatedWorkpsace);
      }
    } catch (e) {
      message.destroy();
      showErrorToast(e, "Failed to update access");
    }
  };

  return (
    <Dialog size="xl" open={open} onClose={onClose}>
      <DialogTitle>{user.firstName}'s Workspace Access</DialogTitle>
      <DialogDescription>Grant Access to Workspaces</DialogDescription>
      <DialogBody>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader className="text-right">Access</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {workspaces?.map((workspace) => {
              if (workspace.createdVia === "Default") {
                return;
              }

              const isChecked = workspace.userAdmin?.includes(user._id);
              return (
                <TableRow key={workspace._id}>
                  <TableCell className="font-medium w-1/2">
                    {workspace.name}
                  </TableCell>
                  <TableCell className="text-zinc-500 text-right w-1/2">
                    <Switch
                      key={`project-switch-${workspace._id}-${user._id}_-${isChecked}`}
                      onChange={(checked) =>
                        updateUserAccessToWorkspace(workspace, checked)
                      }
                      aria-label={`Allow access to ${workspace.name}`}
                      name={`allow_access_${workspace._id}`}
                      id={`project-switch-${workspace._id}`}
                      checked={isChecked}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogBody>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
}
